import { FormaPagoMovimientoCaja } from "./movimientocaja";

export enum TipoMovimientoCajaView {
    /**El movimiento es por un conjunto de guias pagadas en origen en una documentación */
    Documentacion = 0,
    /**Falta por definir, probablemente sea por el dinero recolectado de las guias flete por cobrar en un viaje de entrega a domicilio */
    EntregaDomicilio = 1,
    /**El movimiento es por un conjunto de guias flete por cobrar en una entrega ocurre */
    EntregaOcurre = 2,
    /**El movimiento es por el dinero recolectado de todos los contrarecibos cobrados en un viaje de revisión y cobranza finalizado */
    ViajeCobranza = 3,
    /**El movimiento es por el corte diario, debido a que el corte diario implica también el depósito a banco este movimiento deja la caja en 0 */
    CorteDiario = 4,
    /**El movimiento se genera al cerrar el turno y capturar el CorteTurno correspondiente a las cajas del usuario */
    CorteCajaCargo = 5,
    CorteCajaAbono = 6,
    /**El movimiento proviene de la facturación manual */
    Facturacion = 7,

    /**El movimiento proviene de un movimiento de ajuste de caja */
    AjusteMovimiento = 8,

    /**El movimiento proviene de una entrega de zona extendida */
    EntregaZonaExtendida = 9
}

/**Enum que se usa internamente para darle una llave unica a los movimientos de caja, este valor junto con el IdOrigen determinan la llave del movimiento */
export enum OrigenMovimientoCaja {
    PagoEfectivoGuias = 0,
    ConceptoDesglosePagoGuias = 1,
    Cobranza = 2,
    DepositoBanco = 3,
    TrasladoCorteCaja = 4,
    Facturacion = 5,
    AjusteMovimiento = 6
}

export interface MovimientoCajaView {
    /**Fecha del movimiento */
    Fecha: Date | string;

    Tipo: TipoMovimientoCajaView;

    /**Id de la caja de este movimiento */
    IdCaja: number;

    /**Cargo del movimiento para esta caja y forma de pago */
    Cargo: number;

    /**Abono del movimiento para esta caja y forma de pago */
    Abono: number;

    /**Cargos acumulados a la fecha para esta caja y forma de pago */
    CargosAcum: number;

    /**Abonos acumulados a la fecha para esta caja y forma de pago */
    AbonosAcum: number;

    /**Id del usuario */
    IdUsuario: number;

    /**Forma de pago del movimiento  */
    FormaPago: FormaPagoMovimientoCaja;

    TipoOrigen: OrigenMovimientoCaja;

    /**
     * Nota: Esta columna no esta diseñada para ser utulizada en la logica solamente se usa para darle una llave unica al registro. En caso de que se ocupe el id del movimiento original se tendran
     * que agregar columnas extras con su debida llave foranea
     */
    IdOrigen: number;


}

export interface MovimientoCajaViewDTO extends MovimientoCajaView {
    /**Nombre del usuario que realiza el movmiento */
    NombreUsuario: string;

    /**Nombre de la caja en la que se realiza el movimiento */
    NombreCaja: string;

    /**Referencia del movimiento */
    Referencia: string;
}

export interface FiltroMovimientoCaja {
    FechaCreacionInicio?: Date | string | null;
    FechaCreacionFinal?: Date | string | null;
}


// WEBPACK FOOTER //
// ./app/models/movimientocajaview.ts